/**
 * This file ensures that, if a non-taxable duplicate is passed to the associated products component as a source product, the taxable original product is used to generate the associated products.
 */
(async() => {
  if (typeof window.associatedProductsInitializationCallbacks == 'undefined') {
    window.associatedProductsInitializationCallbacks = [];
  }

  /**
   * Retrieves the taxable original product from the associated products.
   * @param {Object} associatedProducts - The associated products object.
   * @param {Object} sourceProduct - The source product object.
   * @returns {Object|null} The taxable original product object if found, otherwise null.
   */
  function getTaxableOriginalProduct(associatedProducts, sourceProduct) {
    if (! sourceProduct.taxable_original) {
      return null;
    }
    if (sourceProduct.taxable_original === '-' ) {
      return null;
    }

    let taxableOriginalProduct = associatedProducts.allProducts.find(
      (product) => {
        return product.handle === sourceProduct.taxable_original;
      }
    );

    if (typeof taxableOriginalProduct === 'undefined') {
      return null;
    }

    return taxableOriginalProduct;
  }

  // Register initialization callback.
  window.associatedProductsInitializationCallbacks.push(
    (associatedProducts) => {

      // Replace non-taxable duplicate source products with the taxable original products by adding a filter.
      associatedProducts.addFilter(
        'loaded_source_products',
        async (sourceProducts) => {
          for(const i in sourceProducts) {
            let taxableOriginalProduct = getTaxableOriginalProduct(associatedProducts, sourceProducts[i]);

            if (!taxableOriginalProduct) {
              continue;
            }

            sourceProducts[i] = taxableOriginalProduct;
          }

          return sourceProducts;
        }
      );

      associatedProducts.addFilter(
        'loaded_associated_products',
        async (products) => {
          for(const i in products) {
            let taxableOriginalProduct = getTaxableOriginalProduct(associatedProducts, products[i]);

            if (!taxableOriginalProduct) {
              continue;
            }

            products[i] = taxableOriginalProduct;
          }

          return products;
        }
      );
    }
  );
})();
